import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { DATE_TIME_FORMAT } from '../../constants';

const UserDeviceContractsList = ({ deviceContracts, viewUrl }) => (
  <div>
    <h3>Device Contracts</h3>
    <table className="table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Created At</th>
          <th>Expiry Date</th>
          <th>Purchase</th>
          <th>Settled</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {deviceContracts.length > 0 ? (
          deviceContracts.map((deviceContract) => (
            <tr key={deviceContract.id}>
              <td>{deviceContract.id}</td>
              <td>
                {moment(deviceContract.created_at).format(DATE_TIME_FORMAT)}
              </td>
              <td>
                {moment(deviceContract.expiry_date).format(DATE_TIME_FORMAT)}
              </td>
              <td>{deviceContract.purchase}</td>
              <td>{deviceContract.settled}</td>
              <td>
                <Link to={viewUrl(deviceContract)}>Details</Link>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td>No device contracts yet</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default UserDeviceContractsList;
